export default "__VITE_ASSET__BfkipKhs__"